import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import {
  FormControl,
  FormGroupDirective,
  NgForm,
  Validators,
} from "@angular/forms";
import { ErrorStateMatcher } from "@angular/material/core";
import {
  languages as allLanguages,
  LanguageDraft,
} from "src/app/Models/language-models.interface";

export class MyErrorStateMatcher implements ErrorStateMatcher {
  isErrorState(
    control: FormControl | null,
    form: FormGroupDirective | NgForm | null
  ): boolean {
    const isSubmitted = form && form.submitted;
    return !!(
      control &&
      control.invalid &&
      (control.dirty || control.touched || isSubmitted)
    );
  }
}

@Component({
  selector: "app-admin-new-language-dialog",
  templateUrl: "./admin-new-language-dialog.component.html",
  styleUrls: ["./admin-new-language-dialog.component.css"],
})
export class NewLanguageDialogComponent implements OnInit {
  valid = true;
  languages: LanguageDraft[] = Object.keys(allLanguages).map(
    (key) => allLanguages[key]
  );
  constructor(
    public dialogRef: MatDialogRef<NewLanguageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {}

  emailFormControl = new FormControl("", [
    Validators.required,
    Validators.email,
  ]);
  matcher = new MyErrorStateMatcher();

  onCancel(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {}
  validateEmail(email) {
    const re =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.valid = re.test(String(email).toLowerCase());
    return this.valid;
  }
}
